module.exports = __webpack_public_path__ + "static/media/HumanRemains.91487578.webp";